<template>
  {{ time }}
</template>

<script lang="ts">
import { Options, Vue, prop } from "vue-class-component";

class Props {
  seconds = prop<number>({ required: true, default: 0 });
}

@Options({
  components: {},
})
class FormatTime extends Vue.with(Props) {
  get time(): string {
    const mins = Math.floor(this.seconds / 60);
    const secs = Math.floor(this.seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  }
}
export default FormatTime;
</script>

<style lang="scss" scoped></style>
